class GroupErrorTranslation {
    t(error, i18n, groupLabel = 'status') {
        if (groupLabel !== '')
            groupLabel = `${groupLabel}.`

        return i18n.t(`${groupLabel}${error}`);
    }
}

export default new GroupErrorTranslation();
